<template>
    <ConfirmDialog></ConfirmDialog>
    <div class="w-full">
    <div class="sticky-top-bar bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100">
            <div class="flex">

                <div class="w-fit flex justify-start grow-0 pl-2 headTopButtons">
                        <Button  class="icon-button rounded bg-zinc-200 text-zinc-900 border border-zinc-300 hover:bg-zinc-300 dark:bg-zinc-700 dark:text-zinc-100 dark:border-zinc-600 dark:hover:bg-zinc-600 shadow-sm transition-colors" v-tooltip.bottom="'Filtros'" outlined @click="filterSideBarVisible = true">
                                <font-awesome-icon :icon="['fas', 'filter']" /></Button>
                    <span class="p-buttonset">
                        <Button   class="icon-button rounded bg-zinc-200 text-zinc-900 border border-zinc-300 hover:bg-zinc-300 dark:bg-zinc-700 dark:text-zinc-100 dark:border-zinc-600 dark:hover:bg-zinc-600 shadow-sm transition-colors" v-tooltip.bottom="'Refresh'" outlined>
                                <font-awesome-icon :icon="['fas', 'sync']" /></Button>
                        <Button  @click="selectAllPage" class="icon-button rounded bg-zinc-200 text-zinc-900 border border-zinc-300 hover:bg-zinc-300 dark:bg-zinc-700 dark:text-zinc-100 dark:border-zinc-600 dark:hover:bg-zinc-600 shadow-sm transition-colors" v-tooltip.bottom="'Seleccionar Pagina'" >
                                <font-awesome-icon :icon="['fas', 'square-check']" /></Button>
                        <Button  @click="unselectAllPage" class="icon-button rounded bg-zinc-200 text-zinc-900 border border-zinc-300 hover:bg-zinc-300 dark:bg-zinc-700 dark:text-zinc-100 dark:border-zinc-600 dark:hover:bg-zinc-600 shadow-sm transition-colors" v-tooltip.bottom="'Deseleccionar Pagina'">
                                <font-awesome-icon :icon="['fas', 'square']" /></Button>
                        <Button  @click="unselectAllPages" class="icon-button rounded bg-zinc-200 text-zinc-900 border border-zinc-300 hover:bg-zinc-300 dark:bg-zinc-700 dark:text-zinc-100 dark:border-zinc-600 dark:hover:bg-zinc-600 shadow-sm transition-colors" v-tooltip.bottom="'Deseleccionar Todo'">
                                <font-awesome-icon :icon="['fas', 'square-minus']" /></Button>
                    </span>
                     
                    <!--<span class="p-buttonset">
                        <Button  class="icon-button rounded bg-indigo-700" v-tooltip.bottom="'Audios'">
                                <font-awesome-icon :icon="['fas', 'volume-up']" /> Audios</Button>
                        <Button  class="icon-button rounded bg-indigo-700" v-tooltip.bottom="'Videos'">
                                <font-awesome-icon :icon="['fas', 'video']" /> Videos</Button>
                    </span>-->
                    <span class="p-buttonset">
                        <Button  class="icon-button rounded bg-zinc-200 text-zinc-900 border border-zinc-300 hover:bg-zinc-300 dark:bg-zinc-700 dark:text-zinc-100 dark:border-zinc-600 dark:hover:bg-zinc-600 shadow-sm transition-colors" v-tooltip.bottom="'Agregar Musica'" @click="musicModalShow = true;reiniciarMusicModal()">
                                <font-awesome-icon :icon="['fas', 'plus']" /></Button>
                    </span>            
                    <span class="p-buttonset" v-if="selectedSongs.length!=0">
                        <Button @click="killSongs" class="icon-button rounded bg-red-200 text-red-900 border border-red-300 hover:bg-red-300 dark:bg-red-700 dark:text-red-100 dark:border-red-600 dark:hover:bg-red-600 shadow-sm transition-colors" severity="danger" outlined v-tooltip.bottom="'Eliminar Selecciones'">
                                <font-awesome-icon  :icon="['fas', 'trash']"  /></Button>
                    </span>            
                </div>

                <div class=" grow flex justify-end pr-2 headTopFilters">
                    <Dropdown @change="handleFilters" v-model="selectedFilterBy" :options="filterBy" optionLabel="name" class="selectedFilterBy" />
                    <Dropdown @change="handleFilters" v-model="selectedFilterDirection" :options="filterDirection" optionLabel="name" class="selectedFilterDirection" />

                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText class="inputFilter"  v-model="inputFilter"  placeholder="Buscar" @keyup.enter="handleFilters" />
                    </span>
                </div>

            </div>



            <div class="card w-full">
                <Paginator class="paginatorS" :totalRecords="totalSongs" :rows="100" @page="handlePageChange" 
                    :pt="{
                        pageButton: ({ props, state, context }) => ({
                            class: context.active ? 'bg-primary' : undefined
                        })
                    }"
                ></Paginator>
            </div>
        </div>

        <!--<div class="card">
            
            {{ selectedFilterBy.name }} - {{ selectedFilterDirection.name }} - {{ inputFilter }} - {{ paginaActual }} - {{ paginaActual*100 }} - {{ totalSongs }}
            <p>{{ totalSongs }} - {{ numSongsShow }}</p>
            
            
        </div>-->
        
        <ContextMenu ref="routemenu" :model="rowContextOptions" />
            <table class="tagsTableData w-full border border-zinc-200 dark:border-zinc-700 rounded shadow-sm bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100">
            <thead class="bg-zinc-100 text-zinc-900 dark:bg-zinc-800 dark:text-zinc-100">
                <tr>
                    <th class="select" v-tooltip.top="'Canciones Seleccionadas'">{{ selectedSongs.length }}</th>
                    <th class="id">#</th>
                    <th class="title">Titulo</th>
                    <th class="artist">Artista</th>
                    <th class="genero">Género</th>
                    <th class="year">Año</th>
                    <th class="duration">Dur.</th>
                    <th class="play"></th>
                    <th class="tags">Tags</th>
                    <th class="date">Ingresó</th>
                </tr>
            </thead>
            <tbody class="bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100">
                <tr class="tdPlaylists" v-for="song in songsList" :key="song.id" @mouseover="addCheck(song.id)"
                 :song="song.id" :id="song.id" :data-playlists="song.playlists" @contextmenu.prevent="onRowRightClick($event, song.id)"
                 :class="'bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100'">
                    <td class="select nonEditable bg-white dark:bg-zinc-800">
                        <Checkbox @change="handleSelectedSongs" v-model="selectedSongs" :key="song.id" :value="song.id" :name="'SelectedSongsName'" :inputId="song.id.toString()" />
                    </td>
                    <td class="id" @dblclick="songSideBar(song.id)">{{ song.id }}</td>
                    <td class="title">{{ song.name }}</td>
                    <td class="artist">{{ song.artist }}</td>
                    <td class="genero">{{ song.genre }}</td>
                    <td class="year">{{ song.year }}</td>
                    <td class="duration nonEditable">{{ song.duration }}</td>
                    <td class="play nonEditable playButtons">
                        <i @click="onPlaySong(song.location, song.name, song.artist)" class="pi pi-play playSong" v-if=" (song.location!='' && !song.locationmq && !song.locationhq)" :song="song.location"></i>
                        <i @click="onPlaySongMQ(song.locationmq, song.name, song.artist)" class="pi pi-play playSong playSongMQ" v-if="song.locationmq" :song="song.locationmq"><span>MQ</span></i>
                        <i @click="onPlaySongHQ(song.locationhq, song.name, song.artist)" class="pi pi-play playSong playSongHQ" v-if="song.locationhq" :song="song.locationhq"><span>HQ</span></i>

                        <i @click="onPlayVideoHD(song.locationhd, song.name, song.artist)" class="pi pi-video playSong playSongHD" v-if="song.locationhd" :song="song.locationhd"><span>HD</span></i>

                    </td>
                    <td class="tags nonEditable tagList_td">
                        <span class="tagAdd">
                            <Tag @click="addTag(song.id)" icon="pi pi-plus" class="m-0.5 text-xs addTagButton"></Tag>
                        </span> 
                        <Tag v-for="tag in song.tags"  value="Info" :key="tag.id" :id="tag" class="m-0.5 tag" :class="getTagStyle(tag) ? 'tagColoredd' : ''" :style="getTagStyle(tag)">
                            <div class="flex align-items-center gap-2">
                                <span class="text-base text">{{ tag }}</span>
                                <i class="pi pi-times text-xs close pointer" @click="RemoveTagToSongs(song.id, tag)"></i>
                            </div>
                        </Tag>
                    </td>
                    <td class="date nonEditable">
                        {{ song.created_at }}
                    </td>
                    
                </tr>
            </tbody>
        </table>

    </div> 
        

        <Sidebar v-model:visible="songSideBarVisible" position="right" class="w-full md:w-30rem lg:w-30rem">
                
                <div class="p-inputgroup flex-1 row_sb_table">
                    <p >ID:{{ tagSelectedSong }}</p>
                </div>
                <div class="p-inputgroup flex-1 row_sb_table">
                    <p >Titulo</p>
                    <InputText class="w-full" v-model="songSBtitle" ref="songSBtitle" placeholder="" />
                </div>
                <div class="p-inputgroup flex-1 row_sb_table">
                    <p >Artista</p>
                    <InputText class="w-full" v-model="songSBartist" ref="songSBartist" placeholder="" />
                </div>
                <div class="p-inputgroup flex-1 row_sb_table">
                    <p >Género</p>
                    <InputText class="w-full" v-model="songSBgenere" ref="songSBgenere" placeholder="" />
                </div>
                <div class="p-inputgroup flex-1 row_sb_table">
                    <p >Año</p>
                    <InputText class="w-full" v-model="songSBanio" ref="songSBanio" placeholder="" />
                </div>

                <Button @click="uploadTableTag" class="song_sb_saveButton" severity="success" outlined > <font-awesome-icon :icon="['fas', 'edit']" /> Guardar</Button> 

                 
            </Sidebar>


        <Sidebar v-model:visible="tagSideBarVisible" position="right" class="w-full md:w-30rem lg:w-30rem">

            <template #header>
                <div class="flex">
                    <button class="p-sidebar-icon p-link mr-2">
                        <span class="pi pi-song" />
                    </button>
                    <span class="p-sidebar-icon">
                        <font-awesome-icon :icon="['fas', 'music']" />
                    </span>
                    <span class="p-sidebar-icon">
                        {{ selectedSongs.length }}
                    </span>
                </div>
            </template>


                <div class="selected_tags_sb">
                    <small>Tags Seleccionados:</small>
                    <Tag v-for="tag in SelectedTags" value="Info" :key="tag" :id="tag" @click="sideBarRemoveTag(tag)" :class="'tagSB _tagLone'+tag+'_'" class="m-0.5 tag" :style="getTagStyle(tag)">
                        <div class="flex align-items-center gap-2">
                            <span class="text-base text">{{ tag }}</span>
                        </div>
                        <font-awesome-icon :icon="['fas', 'circle-minus']" />
                    </Tag>
                </div>

                <Button @click="SBAddTagToSongs" class="sb_addRemButton sb_addRemButton_1" severity="success" outlined > <font-awesome-icon :icon="['fas', 'music']" /> Agregar</Button>
                <Button @click="SBRemoveTagToSongs" class="sb_addRemButton sb_addRemButton_2" severity="danger" outlined > <font-awesome-icon :icon="['fas', 'music']" /> Eliminar</Button>

                <div class="p-inputgroup flex-1">
                    <InputText v-model="filterText" ref="filter_tags_sb" id="filter_tags_sb" placeholder="Escribe un tag..." />
                    <Button icon="pi pi-plus" severity="info" @click="sideBarAddTag(filterText)"/>
                </div>
                
                <div class="lista_tags_sb">
                    <Tag v-for="tag in filteredTags" value="Info" :key="tag.key" :id="tag.key" @click="sideBarAddTag(tag.key)" :class="'tagSB _tagLone'+tag.key+'_'" class="m-0.5 tag" :style="'background: linear-gradient(145deg, #'+tag.color1+' 0%, #'+tag.color1+' 30%, #'+tag.color2+' 85%, #'+tag.color2+' 100%) !important'">
                        <div class="flex align-items-center gap-2">
                            <span class="text-base text">{{ tag.key }}</span>
                        </div>
                        <font-awesome-icon :icon="['fas', 'circle-plus']" />
                    </Tag>
                </div>
        </Sidebar>
        
 
        <Sidebar v-model:visible="filterSideBarVisible"  position="left" class="w-full md:w-24rem lg:w-24rem filterSideBarVisible relative">
            <template #header>
                <div class="flex">
                    <button class="p-sidebar-icon p-link mr-2" v-styleclass="{ selector: '.filterTypeDiv', enterClass: 'hidden', enterActiveClass: 'my-fadein' }">
                        <span class="pi pi-plus" />
                    </button>
                </div>
            </template>
            <h3 class="sidebarTitle">Filtros Activos</h3>
            <div class="filterTypeDiv hidden animation-duration-500">
                <h3>Agregar Filtro</h3>

                <SelectButton v-model="filterTypeValue" :options="filterType" optionLabel="value" dataKey="value" aria-labelledby="custom" class="p-0 filterType">
                    <template #option="slotProps">
                        <span> {{ slotProps.option.value }}</span>
                    </template>
                </SelectButton>
                
                <SelectButton v-model="filterContentValue" :options="filterContent" optionLabel="value" dataKey="value" aria-labelledby="custom" class="p-0 filterContent" 
                :style="{ display: (filterTypeValue.value == 'Año' || filterTypeValue.value == 'Duración') ? 'none' : 'block' }">
                    <template #option="slotProps">
                        <span> {{ slotProps.option.value }}</span>
                    </template>
                </SelectButton>
                
                <SelectButton v-model="filterDurationValue" :options="filterDuration" optionLabel="value" dataKey="value" aria-labelledby="custom" class="p-0 filterDuration" 
                :style="{ display: (filterTypeValue.value != 'Año' && filterTypeValue.value != 'Duración') ? 'none' : 'block' }">
                    <template #option="slotProps">
                        <span> {{ slotProps.option.value }}</span>
                    </template>
                </SelectButton>

                <div class="p-inputgroup flex-1 filterInputDiv">
                    <InputText v-model="filterInputValue" type="text" size="small" placeholder="rock, pop, top 100" class="filterInput" />
                    <span class="p-inputgroup-addon p-clickable" @click="filterInputValue = ''">
                        <i class="pi pi-times"></i>
                    </span>
                </div>
                <Button @click="SBAddFilter" class="sb_addCloButton sb_addCloButton_1" severity="success" outlined > <font-awesome-icon :icon="['fas', 'plus']" /> Agregar</Button>
                <Button @click="SBCloseFilter" class="sb_addCloButton sb_addCloButton_2" severity="danger" outlined v-styleclass="{ selector: '.filterTypeDiv', leaveActiveClass: 'my-fadeout', leaveToClass: 'hidden' }" > <font-awesome-icon :icon="['fas', 'close']" /> Cancelar</Button>

            </div> 
            <ul class="localFiltersList">
                <li v-for="localFilter in localFilters" :key="localFilter.code" class="localFilter">
                    <span class="localFilterLabel">{{ localFilter.label }}</span>
                    <span class="localFilterClose" @click="localFilters.splice(localFilters.indexOf(localFilter), 1);this.getTagsMusical_list();"><font-awesome-icon :icon="['fas', 'times']" /></span>
                </li>
            </ul>
            

            <Button v-if="localFilters.length !== 0" @click="saveFilterModalShow = true" class="sb_playListButton" severity="success" outlined > <font-awesome-icon :icon="['fas', 'plus']" /> Guardar Filtros Activos</Button>
            <Button v-if="selectedPlaylist " @click="removePlaylist" class="sb_removePlayListButton" severity="danger" outlined > <font-awesome-icon :icon="['fas', 'trash']" /></Button>
            <Dropdown v-model="selectedPlaylist" :options="playlists" filter optionLabel="name" placeholder="Select a Playlist" class="w-full md:w-14rem playlistDropDown" @update:modelValue="handlePlaylistChange">
                <template #value="slotProps">
                    <div v-if="slotProps.value" class="flex align-items-center">
                        <div>{{ slotProps.value.name }}</div>
                    </div>
                    <span v-else>
                        {{ slotProps.placeholder }}
                    </span>
                </template>
                <template #option="slotProps">
                    <div class="flex align-items-center">
                        <div>{{ slotProps.option.name }}</div>
                    </div>
                </template>
            </Dropdown>

            <Dialog v-model:visible="saveFilterModalShow" class="guardarPlaylistModal" modal header="Guardar Filtros Activos en una Playlist" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
                <div class="p-fluid">
                    <div class="p-field">
                        <label for="name">Nombre de la Playlist</label>
                        <InputText v-model="saveFilterInput" />
                    </div>
                    <div class="p-field" :class="{ todos: !saveFilterInput }">
                        <small><i>Si el nombre de la playlist que selecciono es igual a una almacenada con el mismo nombre, esta será reemplazada.</i></small>
                        <br> 
                        <Tag v-for="playlist in filteredPlaylist" value="Info" :key="playlist.name" :id="playlist.name" @click="saveFilterInput = playlist.name" class="tagFilterPlaylist">
                            <div class="flex align-items-center gap-2">
                                <span class="text-base text">{{ playlist.name }}</span>
                            </div>
                            <font-awesome-icon :icon="['fas', 'circle-plus']" />
                        </Tag>
                    </div>
                </div>
                <template #footer>
                    <Button label="Guardar" icon="pi pi-check" severity="success"  @click="saveFilter();saveFilterModalShow = false" />
                    <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="saveFilterModalShow = false" />
                </template>
            </Dialog>
        </Sidebar>

            <!-- Subir musica multiple -->
            <Dialog v-model:visible="musicModalShow" class="guardarMusicaModal" modal header="Subir Musica" 
            :style="{ width: '80vw',   }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
                <div class="card"> 
                    <input type="file" @change="loadMultiFiles($event.target.files)" multiple ref="fileInput" />
                    <ul v-show="files.length" class="fileList_upload">
                        <li v-for="(file, index) in files" :key="index">
                            <div class="flex justify-between item">
                                <div class="flex l_col">
                                    <div class="flex flex-col">
                                        <span class="font-bold name">{{ file.name }}</span>
                                        <span class="text-xs size">{{ file.size }} bytes</span>
                                    </div>
                                </div>
                                <div class="flex r_col">
                                    <span class="text-xs stat_span" :class="'stat_'+file.status">
                                        <font-awesome-icon v-if="file.status == 'espera'" :icon="['fas', 'circle-pause']" />
                                        <font-awesome-icon v-if="file.status == 'subiendo'" :icon="['fas', 'spinner']" />
                                        <font-awesome-icon v-if="file.status == 'terminado'" :icon="['fas', 'circle-check']" />
                                        <font-awesome-icon v-if="file.status == 'error'" :icon="['fas', 'triangle-exclamation']" />
                                        <font-awesome-icon v-if="file.status == 'eliminado'" :icon="['fas', 'ban']" />
                                        {{ file.status }}
                                    </span>
                                    <Button 
                                    @click="removeFile(index)" 
                                    :disabled="file.status === 'eliminado' || file.status === 'subiendo' || file.status === 'terminado'"
                                    class="p-button-rounded p-button-text p-button-plain p-button-sm removeButton" 
                                    icon="pi pi-times" />
                                </div>
                            </div>
                            <ProgressBar :value="file.progress" :showValue="false" />
                        </li>
                    </ul>
                </div>
                <template #footer>
                    <Button label="Subir" icon="pi pi-upload" severity="success" outlined class="icon-button rounded bg-indigo-700" v-if="archivoAuxInput" @click="uploadFile()" /> 
                    <Button label="Cerrar" icon="pi pi-times" severity="info" outlined class="icon-button rounded " @click="musicModalShow = false;reiniciarMusicModal()" />
                </template>
            </Dialog>

            <!-- Subir video por canción -->
            <Dialog v-model:visible="videoModalShow" class="guardarVideoModal" modal header="Subir Video" :disabled="uploadingVideoProgress"
            :style="{ width: '50vw',   }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
                <div class="rounded overflow-hidden shadow-lg">
                    <div class="px-6 py-1">
                        <p class="text-indigo-300 text-base">
                            <font-awesome-icon :icon="['fas', 'user']" /> {{ songAuxXVideo.artist }}
                        </p>
                        <div class="font-bold text-xl mb-2"><font-awesome-icon :icon="['fas', 'music']" /> {{ songAuxXVideo.name }}</div>
                    </div>
                    <div class="px-6 pt-1 pb-2">
                        <span v-show="songAuxXVideo.genre" class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">{{ songAuxXVideo.genre }}</span>
                        <span v-show="songAuxXVideo.year" class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">{{ songAuxXVideo.year }}</span>
                    
                    </div>
                </div>
                <div class="card"> 
                    <div v-if="video" class="flex flex-col items-center justify-center w-full h-auto border-2 border-indigo-300 border-dashed rounded-lg bg-indigo-50 dark:hover:bg-indigo-800 dark:bg-indigo-700 hover:bg-indigo-100 dark:border-indigo-600 dark:hover:border-indigo-500 dark:hover:bg-indigo-600">
                        <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-2 border rounded-lg">
                            <div class="rounded-lg p-4">
                                <video
                                    v-if="videoPreviewUrl"
                                    controls
                                    class="w-full h-auto max-h-[500px] max-w-max rounded-lg"
                                    :src="videoPreviewUrl"
                                    alt="Video Preview">
                                </video>
                            </div>
                            <div class="rounded-lg p-4">
                                <p class="mb-2 text-sm text-gray-400 dark:text-gray-200"><span class="font-semibold">Preview</span></p>
                                <p class="text-xs text-gray-400 dark:text-gray-200">Archivo: {{ video.name }}</p>
                                <p class="text-xs text-gray-400 dark:text-gray-200">Tamaño: {{ (video.size / 1024 / 1024).toFixed(2) }} MB</p>
                                <p class="text-xs text-gray-400 dark:text-gray-200">Tipo: {{ video.type }}</p>
                            </div>
                        </div>
                    </div>
                    <div v-else class="flex items-center justify-center w-full">
                        <label for="videoFileInput" class="flex flex-col items-center justify-center w-full h-64 border-2 border-indigo-300 border-dashed rounded-lg cursor-pointer bg-indigo-50 dark:hover:bg-indigo-800 dark:bg-indigo-700 hover:bg-indigo-100 dark:border-indigo-600 dark:hover:border-indigo-500 dark:hover:bg-indigo-600">
                            <div class="flex flex-col items-center justify-center pt-5 pb-6">
                                <svg class="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"/>
                                </svg>
                                <p class="mb-2 text-sm text-gray-400 dark:text-gray-200"><span class="font-semibold">Click para Subir</span> o arrastra el archivo aqui.</p>
                                <p class="text-xs text-gray-400 dark:text-gray-200">Solo se permiten MP4. (MAX 1080p, 250 MB)</p>
                            </div>
                            <input id="videoFileInput" type="file" @change="loadVideoFile($event.target.files[0])" ref="videoFileInput" class="hidden"/>
                        </label>
                    </div>
                    <div class="bg-indigo-50 dark:bg-indigo-900 rounded-lg p-4 mt-4">
                        <h3 class="font-semibold text-indigo-900 dark:text-indigo-100 mb-3">
                            <font-awesome-icon :icon="['fas', 'info-circle']" /> Requerimientos de Video
                        </h3>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-3 text-xs text-indigo-800 dark:text-indigo-200">
                                    <div class="bg-white dark:bg-indigo-800 p-2 rounded">
                                        <p class="font-semibold">Resolución</p>
                                        <p>1920 × 1080</p>
                                    </div>
                                    <div class="bg-white dark:bg-indigo-800 p-2 rounded">
                                        <p class="font-semibold">Bitrate Video</p>
                                        <p>5 Mbps (máx 5.8 Mbps)</p>
                                    </div>
                                    <div class="bg-white dark:bg-indigo-800 p-2 rounded">
                                        <p class="font-semibold">Codec</p>
                                        <p>H.264 (AVC) - High Profile 4.2</p>
                                    </div>
                                    <div class="bg-white dark:bg-indigo-800 p-2 rounded">
                                        <p class="font-semibold">FPS / GOP</p>
                                        <p>60 FPS / 2 seg (120 frames)</p>
                                    </div>
                                    <div class="bg-white dark:bg-indigo-800 p-2 rounded">
                                        <p class="font-semibold">Audio Codec</p>
                                        <p>AAC-LC - 160 kbps - 48 kHz</p>
                                    </div>
                                    <div class="bg-white dark:bg-indigo-800 p-2 rounded">
                                        <p class="font-semibold">Tamaño Máximo</p>
                                        <p>250 MB</p>
                                    </div>
                        </div>
                    </div>
                </div>
                    <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray- my-3" v-if="videoUploadProgress" >
                        <div class="bg-violet-600 h-2.5 rounded-full"  key="videoUploadProgress" :style="{ width: videoUploadProgress + '%' }"></div>
                    </div>
                <template #footer>
                    <Button label="Subir" icon="pi pi-upload" severity="success" outlined class="icon-button rounded bg-indigo-700" v-if="video" @click="uploadVideoFile()" :disabled="uploadingVideoProgress" /> 
                    <Button label="Cerrar" icon="pi pi-times" severity="info" outlined class="icon-button rounded " @click="videoModalShow = false;reiniciarVideoModal()" :disabled="uploadingVideoProgress" />
                </template>
            </Dialog>
            
</template>


<script>
import axios from 'axios';
import axiosInstance from '../axiosInstance';
 
export default {
    components: {   },
    data() {
        return {
            video: null,
            files: [],
            totalSize: 0,
            totalSizePercent: 0,
            name: '', 
            token: '', 
            user_permission: '',
            songsList: [],
            paginaActual: 0,
            totalSongs: 0,
            numSongsShow: 0,
            pagination: '',
            first: 0,
            selectedFilterBy: '',
            selectedSongs: [],
            selectedSongsNo: 0,
            filterBy: [
                { name: 'Fecha', code: 'id' },
                { name: 'Titulo', code: 'name' },
                { name: 'Artista', code: 'artist' },
                { name: 'Album', code: 'album' },
                { name: 'Genero', code: 'genre' },
                { name: 'Año', code: 'year' },
                { name: 'Duración', code: 'duration' },
            ],
            selectedFilterDirection: '',
            filterDirection: [
                { name: 'Desc', code: 'desc' },
                { name: 'Asc', code: 'asc' },
            ],
            inputFilter: '',
            rowContextOptions: [
                {
                    label: 'Editar',
                    icon: 'pi pi-fw pi-pencil',
                    command: () => {
                        let idSong = this.contextMenuIdSelected;
                        this.contextMenuIdSelected=null;
                        console.log('Editar:', idSong);
                        this.songSideBar(idSong);
                    },
                },
                /*{
                    label: 'Subir archivo',
                    icon: 'pi pi-upload',
                    route: '/fileupload',
                    command: () => {
                        let idSong = this.contextMenuIdSelected;
                        this.contextMenuIdSelected=null;
                        console.log('Subir archivo', idSong);
                    },
                },*/
                {
                    label: 'Eliminar',
                    icon: 'pi pi-fw pi-trash',
                    command: () => {
                        let idSong = this.contextMenuIdSelected;
                        this.contextMenuIdSelected=null;
                        //console.log('Eliminar:', idSong);
                        this.killSong(idSong);
                    },
                },
                {
                    label: 'Subir video',
                    icon: 'pi pi-fw pi-video',
                    command: () => {
                        let idSong = this.contextMenuIdSelected;
                        this.contextMenuIdSelected=null;
                        //console.log('Subir video:', idSong);
                        this.videoModalShow = true;
                        this.reiniciarVideoModal();
                        this.openVideoModal(idSong);
                    },
                },
            ],
            tagSideBarVisible: false,
            songSideBarVisible: false,

            songSBtitle: '',
            songSBartist: '',
            songSBgenere: '',
            songSBanio: '',

            tagSelectedSong: '',
            tagsColorList: [],
            ftagsColorList: [],
            filterText: "",
            SelectedTags: [],
            filterSideBarVisible: false,
            selectedPlaylist: null,
            playlists: [],
            fplaylists: [],
            saveFilterInput: "",
            filterTypeValue: { icon: 'pi pi-align-justify', value: 'Tag' },
            filterType: [
                { icon: 'pi pi-align-left', value: 'Titulo' },
                { icon: 'pi pi-align-right', value: 'Artista' },
                { icon: 'pi pi-align-center', value: 'Album' },
                { icon: 'pi pi-align-justify', value: 'Genero' },
                { icon: 'pi pi-align-justify', value: 'Año' },
                { icon: 'pi pi-align-justify', value: 'Duración' },
                { icon: 'pi pi-align-justify', value: 'Tag' }
            ],
            filterContentValue: { icon: 'pi pi-align-left', value: 'que contenga' },
            filterContent: [
                { icon: 'pi pi-align-left', value: 'que contenga' },
                { icon: 'pi pi-align-right', value: 'que no contenga' }
            ],
            filterDurationValue: { icon: 'pi pi-align-left', value: 'desde' },
            filterDuration: [
                { icon: 'pi pi-align-left', value: 'desde' },
                { icon: 'pi pi-align-right', value: 'hasta' },
                { icon: 'pi pi-align-center', value: 'igual que' }
            ],
            filterInputValue: null,
            localFilters: [],
            saveFilterModalShow: false,
            musicModalShow: false,
            contextMenuIdSelected: null,
            archivoAuxInput: null,
            videoModalShow: false, 
            songAuxXVideo: null,
            videoUploadProgress: null,
            uploadingVideoProgress: false,
        };
    },
    props: {
        isLoading: Boolean, 
    },
  computed: {
        videoPreviewUrl() {
            if (typeof window !== 'undefined' && this.video) {
                return URL.createObjectURL(this.video);
            }
            return null;
        },
        filteredTags() {
            // Filtrar tags basados en el valor del input
            //console.log('filteredTags:','Filtrar tags basados en el valor del input');
            return this.ftagsColorList.filter(tag => {
                //console.log('filteredTags:','tag.key:', tag.key);
                return tag.key.toLowerCase().includes(this.filterText.toLowerCase());
            });
        },
        filteredPlaylist() {
            return this.fplaylists.filter(playlist => {
                const playlistName = this.removeAcentos(playlist.name.toLowerCase());
                const searchQuery = this.removeAcentos(this.saveFilterInput.toLowerCase());
                return playlistName.includes(searchQuery) || playlistName.includes(searchQuery.replace(/'/g, ''));
            });
        },
        localFiltersComputed() {
            console.log("==WACHADO====================");
            console.log(this.localFilters);
            console.log("==WACHADO====================");
            return this.localFilters;
        },
    },
    methods: { 
        // FILE MANAGER
        uploadVideoFile() {
            if (!this.songAuxXVideo || !this.video) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Falta seleccionar archivo de video.', life: 5000, group: 'topr' });
                return;
            }
            console.log("Uploading video file...");
            // songAuxXVideo
            let fileName = this.songAuxXVideo.locationhq.slice(0, -4) + '.mp4';
            let archivoParaSubir = this.video;
            let songId = this.songAuxXVideo.id;
            console.log("fileName",fileName);
            console.log("archivoParaSubir",archivoParaSubir);
            console.log("songId",songId);
            this.getPresigned_VideoUrl(fileName, archivoParaSubir, songId);
        },

        async getPresigned_VideoUrl(fileName, archivoParaSubir, songId) {
            const SIZE_LIMIT = 80 * 1024 * 1024; // 80MB

            if (archivoParaSubir.size < SIZE_LIMIT) {
                return this.getPresignedVideoSimple(fileName, archivoParaSubir, songId);
            } else {
                return this.uploadVideoMultipart(fileName, archivoParaSubir, songId);
            }
        },

        async getPresignedVideoSimple(fileName, archivoParaSubir, songId) {
            this.$emit('update-loading', true);

            try {
                const response = await axiosInstance.post("/transmito/get_presigned_url", {
                fileName: 'mp4_video/' + fileName
                });

                if (!response.data) throw new Error('No presigned url');

                await this.uploadVideoCloudfler(
                response.data,
                archivoParaSubir,
                songId,
                fileName
                );
            } catch (e) {
                this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: e.message || e,
                life: 5000,
                group: 'topr'
                });
            } finally {
                this.$emit('update-loading', false);
            }
        },
        
        async uploadVideoCloudfler(presignedUrl, archivoParaSubir, songId, fileName){
            this.uploadingVideoProgress = true;
            console.log("===uploadCloudflare=====================")
            this.$emit('update-loading', true);
            console.log("presignedUrl",presignedUrl);
                    try {
                        const response = await axiosInstance(  {
                                url: presignedUrl.replace(
                                    'https://vybroo-media.36849d2e964ee51fea8d00d8d1f680eb.r2.cloudflarestorage.com/', 
                                    'vybroo-media/'
                                ),
                                method: 'PUT',
                                data: archivoParaSubir,
                                headers: {
                                    'Content-Type': 'video/mp4'
                                },
                                onUploadProgress : (progressEvent) => {
                                    const total = progressEvent.total;
                                    const current = progressEvent.loaded;
                                    this.videoUploadProgress = Math.round((current / total) * 100);
                                    //console.log("videoUploadProgress",this.videoUploadProgress);
                                },
                        });
                        
                        console.log("uploadFile",response);
                        const [ res ] = await Promise.all([response]);
                        console.log("uploadFile",res);
                        if (res.request.status != 200) {
                            this.$toast.add({ severity: 'error', summary: 'Error Axios', detail: 'Error al subir el archivo: Status:'+res.request.statusText, life: 5000, group: 'topr' });
                            this.reiniciarVideoModal();
                            this.$emit('update-loading', false);
                            this.videoUploadProgress = null;
                            this.uploadingVideoProgress = false;
                        }else{
                            const formData = new FormData();
                            formData.append('song_id', songId);
                            formData.append('bit_r', 10);
                            formData.append('file_ext', 'mp4');
                            formData.append('location', fileName);

                            const saveDBinfo = await axiosInstance.post("/api/save_video_quality", formData);
                            console.log("saveDBinfo", saveDBinfo.data);
                            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'Video de la canción subida con exito', life: 5000, group: 'topr' });
                                    try {
                                        const response = axiosInstance.post("/api/save_extra_tag", {
                                            token: localStorage.getItem('token'),
                                            songs: [songId],
                                            value: "AudioVisual"
                                        });
                                        const [ res ] = await Promise.all([response]);
                                        console.log("AddAudioVisualTag", res);
                                        if (res.data.error) { 
                                            this.$toast.add({ severity: 'error', summary: 'Error al agregar tag AudioVisual', detail: res.data.message, life: 5000, group: 'topr' });
                                        }
                                    } catch (error) {
                                        console.error("AddAudioVisualTag: There was an error!", error);
                                    }
                            this.$emit('update-loading', false);
                            this.videoModalShow = false;
                            this.reiniciarVideoModal();
                            this.loadPlayList(); 
                            this.getTagsMusical_list();
                            this.videoUploadProgress = null;
                            this.uploadingVideoProgress = false;

                        }
                    } catch (error) {
                        console.error("uploadFile: There was an error!", error);
                        this.$toast.add({ severity: 'error', summary: 'Error Catch', detail: error, life: 5000, group: 'topr' });
                        this.$emit('update-loading', false);
                            this.videoUploadProgress = null;
                            this.uploadingVideoProgress = false;
                    }
                    
            console.log("===uploadCloudflare=====================")
        },

        async uploadVideoMultipart(fileName, archivoParaSubir, songId) {
            this.uploadingVideoProgress = true;
            this.videoUploadProgress = 0;
            this.$emit('update-loading', true);

            const CHUNK_SIZE = 10 * 1024 * 1024; // 10MB
            const totalParts = Math.ceil(archivoParaSubir.size / CHUNK_SIZE);
            const uploadedParts = [];

            try {
                const createRes = await axiosInstance.post('/transmito/create_multipart_upload', {
                fileName: 'mp4_video/' + fileName
                });

                const uploadId = createRes.data.uploadId;

                for (let partNumber = 1; partNumber <= totalParts; partNumber++) {
                const start = (partNumber - 1) * CHUNK_SIZE;
                const end = Math.min(start + CHUNK_SIZE, archivoParaSubir.size);
                const chunk = archivoParaSubir.slice(start, end);

                const signRes = await axiosInstance.post('/transmito/sign_upload_part', {
                    fileName: 'mp4_video/' + fileName,
                    uploadId,
                    partNumber
                });

                const res = await axios.put(signRes.data.url, chunk, {
                    headers: { 'Content-Type': 'video/mp4' },
                    maxBodyLength: Infinity,
                    maxContentLength: Infinity,
                    onUploadProgress: (e) => {
                    const bytesHastaParteAnterior = (partNumber - 1) * CHUNK_SIZE;
                    const totalSubido = bytesHastaParteAnterior + e.loaded;
                    this.videoUploadProgress = Math.round(
                        (totalSubido / archivoParaSubir.size) * 100
                    );
                    }
                });

                let etag = res.headers['etag'] || res.headers['ETag'];
                if (!etag) {
                    console.error('No ETag devuelto para la parte', partNumber, res.headers);
                    throw new Error('No ETag devuelto por R2 (revisa CORS ExposeHeaders["ETag"])');
                }

                etag = etag.replace(/"/g, '');

                uploadedParts.push({
                    PartNumber: partNumber,
                    ETag: etag
                });
                }

                console.log('uploadedParts >>>', uploadedParts);

                await axiosInstance.post('/transmito/complete_multipart_upload', {
                fileName: 'mp4_video/' + fileName,
                uploadId,
                parts: uploadedParts
                });

                const formData = new FormData();
                formData.append('song_id', songId);
                formData.append('bit_r', 10);
                formData.append('file_ext', 'mp4');
                formData.append('location', fileName);

                await axiosInstance.post('/api/save_video_quality', formData);

                this.$toast.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Video de la canción subida con éxito',
                life: 5000,
                group: 'topr'
                });

                    try {
                        const response = axiosInstance.post("/api/save_extra_tag", {
                            token: localStorage.getItem('token'),
                            songs: [songId],
                            value: "AudioVisual"
                        });
                        const [ res ] = await Promise.all([response]);
                        console.log("AddAudioVisualTag", res);
                        if (res.data.error) { 
                            this.$toast.add({ severity: 'error', summary: 'Error al agregar tag AudioVisual', detail: res.data.message, life: 5000, group: 'topr' });
                        }
                    } catch (error) {
                        console.error("AddAudioVisualTag: There was an error!", error);
                    }

                this.videoModalShow = false;
                this.reiniciarVideoModal();
                this.loadPlayList();
                this.getTagsMusical_list();

            } catch (error) {
                console.error(error);
                this.$toast.add({
                severity: 'error',
                summary: 'Error Multipart',
                detail: error.message || error,
                life: 5000,
                group: 'topr'
                });
            } finally {
                this.videoUploadProgress = null;
                this.uploadingVideoProgress = false;
                this.$emit('update-loading', false);
            }
        },

        openVideoModal(songId) {
            this.tagSelectedSong = songId;
            const song = this.songsList.find(song => song.id == songId);
            if (song) {
                this.songAuxXVideo = song;
                console.log("song",song);
            }
            this.videoModalShow = true;
        }, 
        loadVideoFile(file) { 
            //print file info
            console.log("===loadVideoFile=====================");
            console.log("file",file);
            console.log("file.name",file.name);
            console.log("file.size",file.size);
            console.log("file.type",file.type);
            console.log("===loadVideoFile=====================");
            if (file.type !== 'video/mp4') {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'El archivo no es un video MP4', life: 5000, group: 'topr' });
                this.$refs.videoFileInput.value = null;
                this.video = null;
                return;
            }else{
                if (file.size > 250 * 1024 * 1024) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: 'El archivo no cumple con las limitaciones establecidas como máximas. (Máximo 250 MB)', life: 5000, group: 'topr' });
                    this.$refs.videoFileInput.value = null;
                    this.video = null;
                    return;
                }
                this.$toast.add({ severity: 'info', summary: '', detail: 'Archivo con formato correcto.', life: 5000, group: 'topr' });
                this.video = file;
            }
        }, 
        reiniciarVideoModal(){
            this.video=null;
            this.videoPreviewUrl=null;
            if (this.$refs.videoFileInput) {
                this.$refs.videoFileInput.value = null;
            }
            this.songAuxXVideo=null;
        },
        reiniciarMusicModal(){
            this.files=[];
            this.archivoAuxInput=null; 
        },
        loadMultiFiles(archivoXSubir) {
            this.archivoAuxInput = archivoXSubir;
            this.files=[]; 
            for (let index = 0; index < archivoXSubir.length; index++) {
                const element = archivoXSubir[index];
                element.status = 'espera';
                this.files.push(element); 
            }
            console.log("this.files",this.files);
        },
        removeFile(index) {
            //SET FILE STATUS
            let filesAux = this.files;
            filesAux[index].status = 'eliminado'; 
            this.files=[]; 
            this.files=filesAux;
            console.log("this.files",this.files); 
        },
        statSubiendoFile(index) {
            let filesAux = this.files;
            filesAux[index].status = 'subiendo'; 
            this.files=[]; 
            this.files=filesAux;
            console.log("this.files",this.files); 
        },
        statTerminadoFile(index) {
            let filesAux = this.files;
            filesAux[index].status = 'terminado';
            this.files=[]; 
            this.files=filesAux;
            console.log("this.files",this.files); 
        },
        statErrorFile(index) {
            let filesAux = this.files;
            filesAux[index].status = 'error';
            this.files=[]; 
            this.files=filesAux;
            console.log("this.files",this.files); 
        },
        // FILE MANAGER
        // ═══════════════════════════════════════════════════════════════
        // UPLOAD FILE — Flujo con normalización a -14 LUFS
        // El backend (save_song_info) ahora:
        //   1. Extrae metadata del MP3
        //   2. Normaliza a -14 LUFS y sube el normalizado a R2 (mp3_320_norm/)
        //   3. Genera versión 128k desde el normalizado y la sube a R2 (mp3_128/)
        // El frontend solo sube el original 320 a R2 via presigned URL
        // ═══════════════════════════════════════════════════════════════
        async uploadFile(){
            const archivoXSubir = this.archivoAuxInput;
            console.log("===uploadFile=====================")
            this.$emit('update-loading', true);
            for (let i = 0; i < this.files.length; i++) {
                if (this.files[i].status != 'eliminado' && this.files[i].status != 'terminado' && this.files[i].status != 'subiendo') {
                    this.statSubiendoFile(i);
                    const archivoParaSubir = archivoXSubir[i];
                    console.log("archivoParaSubir",archivoParaSubir);
                    this.$emit('update-loading', true);
                    // Enviamos el archivo para sacar metadata, normalizar y almacenar en DB
                    const formData = new FormData();
                        formData.append('audio', archivoParaSubir);
                    try{
                        const getMETADATA = axiosInstance.post("/api/save_song_info", formData);
                        const [ metadata ] = await Promise.all([getMETADATA]);

                        if (metadata.data.error) {
                            const errMsg = metadata.data.message?.message || metadata.data.message || 'Error al procesar el archivo';
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: errMsg, life: 8000, group: 'topr' });
                            this.statErrorFile(i);
                            continue;
                        }

                            console.log("metadata",metadata);
                            console.log("file",metadata.data.file);
                            console.log("name",metadata.data.name);
                            console.log("bitrate",metadata.data.bitrate);
                            console.log("id",metadata.data.song.id);
                            console.log("normalized",metadata.data.normalized);
                            console.log("loudness",metadata.data.loudness);
                            console.log("===uploadFile=====================")

                        if (metadata.data.bitrate >= 320 && metadata.data.bitrate <= 321){
                            // El normalizado y el 128k ya se subieron a R2 desde el backend
                            // Solo resta subir el original 320 a R2
                            this.getPresigned_Url(metadata.data.file, archivoParaSubir, metadata.data.song.id, i);
                        }else{
                            this.statErrorFile(i);
                            this.killDirectSong(metadata.data.song.id);
                            this.getTagsMusical_list();
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: 'El archivo no es de 320kbps', life: 5000, group: 'topr' });
                        }
                    }catch (error) {
                        console.error("save_song_info: There was an error!", error);
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000, group: 'topr' });
                        this.statErrorFile(i);
                    }    
                }
            }
            this.$emit('update-loading', false);
        },

        async getPresigned_Url(fileName, archivoParaSubir, songId, index){ 
            console.log("===getPresigned_Url=====================")
            this.$emit('update-loading', true);
            const response2 = await axiosInstance.post("/transmito/get_presigned_url", {
                fileName: 'mp3_320/'+fileName
            });

                console.log("response2",response2);
                console.log("response2",response2.data);
                console.log("===getPresigned_Url=====================")
                this.uploadCloudfler(response2.data, archivoParaSubir, songId, index);
                this.$emit('update-loading', false);
        },

        async uploadCloudfler(presignedUrl, archivoParaSubir, songId, index){
            console.log("===uploadCloudflare=====================")
            this.$emit('update-loading', true);
                    try { 
                        const response = await axiosInstance(  {
                                url: presignedUrl.replace('https://vybroo-media.36849d2e964ee51fea8d00d8d1f680eb.r2.cloudflarestorage.com/', 'vybroo-media/'),
                                method: 'PUT',
                                data: archivoParaSubir,
                                headers: {
                                    'Content-Type': 'audio/mpeg'
                                }
                        });
                        
                        console.log("uploadFile",response);
                        const [ res ] = await Promise.all([response]);
                        console.log("uploadFile",res);
                        if (res.request.status != 200) {
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Error al subir el archivo: Status:'+res.request.statusText, life: 5000, group: 'topr' });
                            this.killDirectSong(songId);
                            this.$emit('update-loading', false);
                            this.statErrorFile(index);
                        }else{
                            this.statTerminadoFile(index);
                            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'Canción subida y normalizada con exito', life: 5000, group: 'topr' });
                            this.$emit('update-loading', false);
                            this.loadPlayList();
                            this.localFilters=[]; 
                            this.getTagsMusical_list();
                            this.selectedPlaylist = null;
                        }
                    } catch (error) {
                        console.error("uploadFile: There was an error!", error);
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000, group: 'topr' });
                        this.$emit('update-loading', false);
                        this.statErrorFile(index);
                    }
                    
            console.log("===uploadCloudflare=====================")
        },
        
        async killDirectSong(idSong){
            console.log("===killDirectSong=====================")
                    try {
                        let songs = [];
                        songs.push(idSong);
                        let filterRequest = {
                                token: localStorage.getItem('token'),
                                sort: {
                                    direction: this.selectedFilterDirection.code,
                                    by: this.selectedFilterBy.code
                                },
                                songs: songs
                        }; 
                        // Si se cuenta con Filtros extras, se agregan a la petición
                        if (this.localFilters.length !== 0) {
                            let localFiltersCode = [];
                            this.localFilters.forEach(localFilter => {
                                localFiltersCode.push(localFilter.code);
                            });
                            filterRequest.filters = localFiltersCode;
                        }
                        const responseF = axiosInstance.post("/api/kill_song", filterRequest);

                        const [ result
                        ] = await Promise.all([
                                responseF
                        ]);
                        
                        if (result.data.success) {
                            return true;
                        }else{
                            return false;
                        }

                    } catch (error) {
                        console.error("killDirectSong: There was an error!", error);
                        return error;
                    }
        },
        
        async killSong(idSong){
            console.log("===killSong=====================")
            this.$emit('update-loading', true);
            this.$confirm.require({
                message: '¿Seguro que quieres eliminar la cancion con el id:"'+idSong+'"?',
                header: 'Confirmación de eliminación',
                icon: 'pi pi-info-circle',
                rejectLabel: 'Cancelar',
                acceptLabel: 'Eliminar',
                rejectClass: 'p-button-secondary p-button-outlined',
                acceptClass: 'p-button-danger',
                accept: async () => {
 
                    try { 
                        let songs = [];
                        songs.push(idSong);
                        let filterRequest = {
                                token: localStorage.getItem('token'),
                                sort: {
                                    direction: this.selectedFilterDirection.code,
                                    by: this.selectedFilterBy.code
                                },
                                songs: songs
                        }; 
                        // Si se cuenta con Filtros extras, se agregan a la petición
                        if (this.localFilters.length !== 0) {
                            let localFiltersCode = [];
                            this.localFilters.forEach(localFilter => {
                                localFiltersCode.push(localFilter.code);
                            });
                            filterRequest.filters = localFiltersCode;
                        }
                        const responseF = axiosInstance.post("/api/kill_song", filterRequest);

                        const [ result
                        ] = await Promise.all([
                                responseF
                        ]);
                        
                        if (result.data.success) {
                            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'La cancion fue eliminada correctamente', life: 5000, group: 'topr' });
                            this.getTagsMusical_list();
                        }else{
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: 'La cancion no se pudo eliminar, intente mas tarde.', life: 5000, group: 'topr' });
                        }

                    } catch (error) {
                        console.error("uploadFile: There was an error!", error);
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000, group: 'topr' });
                    }
                    
                }
            }); 
            console.log("===killSong=====================")
            this.$emit('update-loading', false);
        },
        async killSongs(){
            console.log("===killSong=====================")
            let message_aux = '¿Seguro que quieres eliminar las "'+this.selectedSongs.length+'" canciones seleccionadas?';
            if (this.selectedSongs.length == 1) {
                message_aux = '¿Seguro que quieres eliminar la cancion seleccionada?';
            }
            this.$emit('update-loading', true);
            this.$confirm.require({
                message: message_aux,
                header: 'Confirmación de eliminación',
                icon: 'pi pi-info-circle',
                rejectLabel: 'Cancelar',
                acceptLabel: 'Eliminar',
                rejectClass: 'p-button-secondary p-button-outlined',
                acceptClass: 'p-button-danger',
                accept: async () => {
                    console.log("this.selectedSongs",this.selectedSongs);
                    try { 
                        let songs = [];
                        this.selectedSongs.forEach(songg => {
                            songs.push(songg);
                        });
                        let filterRequest = {
                                token: localStorage.getItem('token'),
                                sort: {
                                    direction: this.selectedFilterDirection.code,
                                    by: this.selectedFilterBy.code
                                },
                                songs: songs
                        }; 
                        // Si se cuenta con Filtros extras, se agregan a la petición
                        if (this.localFilters.length !== 0) {
                            let localFiltersCode = [];
                            this.localFilters.forEach(localFilter => {
                                localFiltersCode.push(localFilter.code);
                            });
                            filterRequest.filters = localFiltersCode;
                        }
                        const responseF = axiosInstance.post("/api/kill_song", filterRequest);

                        const [ result
                        ] = await Promise.all([
                                responseF
                        ]);
                        console.log("killSongs:result:",result);
                        if (result.data.success) {
                            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'Las canciones fueron eliminadas correctamente', life: 5000, group: 'topr' });
                            this.getTagsMusical_list();
                            this.selectedSongs = [];
                        }else{
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Las canciones no se pudieron eliminar, intente mas tarde.', life: 5000, group: 'topr' });
                        }

                    } catch (error) {
                        console.error("uploadFile: There was an error!", error);
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000, group: 'topr' });
                    }
                }
            }); 
            console.log("===killSong=====================")
            this.$emit('update-loading', false);
        },

        removePlaylist(){
            this.$confirm.require({
                message: '¿Seguro que quieres eliminar la Playlist "'+this.selectedPlaylist.name+'"?',
                header: 'Confirmación de eliminación',
                icon: 'pi pi-info-circle',
                acceptClass: 'p-button-danger',
                accept: async () => {
                    this.$emit('update-loading', true);
                    try {
                        const response = axiosInstance.post("/api/kill_saved_filter", {
                                token: localStorage.getItem('token'),
                                filter: this.selectedPlaylist.id
                        });
                        
                        console.log("removePlaylist",response);
                        const [ res ] = await Promise.all([response]);
                        console.log("removePlaylist",res);
                        if (res.data.error) { 
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: res.data.message, life: 5000, group: 'topr' });
                        }else{
                            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'La playlist "'+this.selectedPlaylist.name+'" se elimino correctamente', life: 5000, group: 'topr' });
                            this.loadPlayList();
                            this.localFilters=[]; 
                            this.getTagsMusical_list();
                            this.selectedPlaylist = null;
                        }
                    } catch (error) {
                        console.error("removePlaylist: There was an error!", error);
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000, group: 'topr' });
                    } 
                    this.$emit('update-loading', false);
                }
            }); 
        },
        async handlePlaylistChange() {
            if (this.selectedPlaylist === null) { return; }
            console.log('handlePlaylistChange:', this.selectedPlaylist.id , this.selectedPlaylist.name);
            this.$emit('update-loading', true);
            try {
                let filterRequest = {
                        token: localStorage.getItem('token'),
                        filter: this.selectedPlaylist.id
                };  
                const response = axiosInstance.post("/api/load_saved_filter", filterRequest);

                const [ res
                ] = await Promise.all([
                        response
                ]); 
                 
                console.log("RES:",res); 
                if (res.data.success) {
                    let filters = res.data.data.filters.split("|");
                    console.log('filters:', filters);
                    this.localFilters = [];
                    filters.forEach(filter => {
                        let filterSplit = filter.split("~");
                        let label = filterSplit[0] + " " + this.untranslateFilterCode(filterSplit[1]) + " " + filterSplit[2];
                        let code  = filterSplit[0] + "~" + filterSplit[1] + "~" + filterSplit[2];
                        let filterrr = {
                            label: label,
                            code: code
                        };
                        this.localFilters.push(filterrr);
                    });
                    this.getTagsMusical_list();

                    this.$toast.add({ 
                        severity: 'success', 
                        summary: 'Exito', 
                        detail: 'La playlist "'+res.data.data.name+'" cargo correctamente',
                        life: 5000, group: 'topr'
                    });
                }else{
                    this.$toast.add({ 
                        severity: 'error', 
                        summary: 'Error', 
                        detail: res.data.message,
                        life: 5000, group: 'topr'
                    });
                }

            } catch (error) {
                console.error("getYearToDay: There was an error!", error);
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Error al guardar el filtro', 
                    detail: error,
                    life: 5000, group: 'topr'
                });
            }
            this.$emit('update-loading', false);
        },
        removeAcentos(str) {
            return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        },
        async saveFilter(){
 
            this.$emit('update-loading', true);
            try {
                let filterRequest = {
                        token: localStorage.getItem('token'),
                        name: this.saveFilterInput,
                        mode: "audio"
                }; 
                if (this.localFilters.length !== 0) {
                    let localFiltersCode = [];
                    this.localFilters.forEach(localFilter => {
                        localFiltersCode.push(localFilter.code);
                    });
                    filterRequest.filters = localFiltersCode;
                }
                console.log('===Request SAVE FILTER:', filterRequest);
                const response = axiosInstance.post("/api/save_filters", filterRequest);

                const [ res
                ] = await Promise.all([
                        response
                ]); 
                 
                console.log("RES:",res); 
                if (res.data.success) {
                    this.$toast.add({ 
                        severity: 'success', 
                        summary: 'Exito', 
                        detail: 'La playlist "'+this.saveFilterInput+'" se guardo correctamente',
                        life: 5000, group: 'topr'
                    });
                    this.loadPlayList();
                }else{
                    this.$toast.add({ 
                        severity: 'error', 
                        summary: 'Error', 
                        detail: res.data.message,
                        life: 5000, group: 'topr'
                    });
                }

            } catch (error) {
                console.error("getYearToDay: There was an error!", error);
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Error al guardar el filtro', 
                    detail: error,
                    life: 5000, group: 'topr'
                });
            }
            this.$emit('update-loading', false);

        },
        getTagStyle(tag) {
            //console.log('getTagStyle:', tag);
            if (this.tagsColorList[tag] === undefined) {
                //return "background: linear-gradient(145deg, #e1e1e1 0%, #e1e1e1 48%, #e1e1e1 100%) !important";
            }else{
                //console.log('getTagStyle::::result', this.tagsColorList[tag]['color1'],this.tagsColorList[tag]['color2']);
                let stringReturn = 
                "background: linear-gradient(145deg, #"+
                    this.tagsColorList[tag]['color1']+
                    " 0%, #"+this.tagsColorList[tag]['color1']+
                    " 30%, #"+this.tagsColorList[tag]['color2']+
                    " 85%, #"+this.tagsColorList[tag]['color2']+
                    " 100%) !important"; 
                //"background: linear-gradient(145deg, #da00ff 0%, #da00ff 30%, #e1e1e1 85%, #e1e1e1 100%) !important";
                return stringReturn;
                
            } 
        },
        addTag(songId) {
            console.log('Agregar tag:', songId);
            this.tagSelectedSong = songId;
            this.tagSideBarVisible = true;
            if (!this.selectedSongs.includes(songId)) {
                this.selectedSongs.push(songId);    
            }
        },
        songSideBar(songId){
            this.songSideBarVisible = true;
            this.tagSelectedSong = songId;
            const song = this.songsList.find(song => song.id == songId);
            if (song) {
                this.songSBtitle = song.name;
                this.songSBartist = song.artist;
                this.songSBgenere = song.genre;
                this.songSBanio = song.year;
            }
        },
        addCheck(songId) {
            // IF SHIFT IS PRESSED 
            if (event.shiftKey) {
                console.log('SHIFT PRESIONADO');
                //si la cancion ya esta seleccionada, no agregarla
                if (!this.selectedSongs.includes(songId)) {
                    this.selectedSongs.push(songId);
                }else{
                    this.selectedSongs.splice(this.selectedSongs.indexOf(songId), 1);
                }
            }
        },
        SBAddFilter() {
            //Agrega los valores seleccionados para agregar filtros a la lista de filtros local
            this.addLocalFilter(this.filterInputValue);
        },
        SBCloseFilter() {},
        addLocalFilter(lfilter) {
            if (lfilter === null) { 
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'El valor del filtro no puede estar vacio', 
                    life: 5000, group: 'topr'
                });
                return; 
            }
            if (lfilter === "") {
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'El valor del filtro no puede estar vacio', 
                    life: 5000, group: 'topr'
                });
                return; 
            }
            if (lfilter.indexOf("~") !== -1) {
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'El valor del filtro no puede contener "~"', 
                    life: 5000, group: 'topr'
                });
                return; 
            }
            if (lfilter.indexOf("|") !== -1) {
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'El valor del filtro no puede contener "|"', 
                    life: 5000, group: 'topr'
                });
                return; 
            }
 
            let valueCode = "";
            if ((this.filterTypeValue.value) === "Año" || 
                (this.filterTypeValue.value) === "Duración") {
                valueCode = this.filterDurationValue.value;
            }else{
                valueCode = this.filterContentValue.value;
            }
            let label = this.filterTypeValue.value + " " + (valueCode) + " " + lfilter;
            let code  = this.filterTypeValue.value + "~" + this.translateFilterCode(valueCode) + "~" + lfilter;

            let filter = {
                label: label,
                code: code
            };

            //check if filter already exists in localfilters
            if (this.localFilters.some(localFilter => localFilter.label === filter.label && localFilter.code === filter.code)) {
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'El filtro ya existe', 
                    life: 5000, group: 'topr'
                });
            }else {
                this.localFilters.push(filter);
                this.$toast.add({ 
                    severity: 'success', 
                    summary: 'Filtro agregado correctamente', 
                    life: 5000, group: 'topr'
                });
                setTimeout(() => {
                    this.getTagsMusical_list();
                }, 500);
            }
            console.log('localFilters:', this.localFilters);
        },
        translateFilterCode(label){
            switch (label) {
                case 'que contenga':
                    return 'do';
                case 'que no contenga':
                    return 'not';
                case 'igual que':
                    return 'eq';
                case 'desde':
                    return 'gte';
                case 'hasta':
                    return 'lte';
            }
        },
        untranslateFilterCode(label){
            switch (label) {
                case 'do':
                    return 'que contenga';
                case 'not':
                    return 'que no contenga';
                case 'eq':
                    return 'igual que';
                case 'gte':
                    return 'desde';
                case 'lte':
                    return 'hasta';
            }
        },
        async SBAddTagToSongs() {
            console.log('Agregar tag:', this.SelectedTags);
            console.log('Canciones seleccionadas:', this.selectedSongs);
            this.$emit('update-loading', true);
            this.SelectedTags.forEach(async tag => {
                try {
                    const response = axiosInstance.post("/api/save_extra_tag", {
                            token: localStorage.getItem('token'),
                            songs: this.selectedSongs,
                            value: tag
                    });
                    const [ res ] = await Promise.all([response]);
                    console.log("SBAddTagToSongs",res);
                    if (res.data.error) { 
                        this.$toast.add({ severity: 'error', summary: 'Error en '+tag, detail: res.data.message, life: 5000, group: 'topr' });
                    }
                } catch (error) {
                    console.error("getYearToDay: There was an error!", error);
                }
            });
            
            setTimeout(() => {
                this.getTagsMusical_list();
            }, 1000);
        },
        async SBRemoveTagToSongs() {
            console.log('Eliminar tag:', this.SelectedTags);
            console.log('Canciones seleccionadas:', this.selectedSongs);
            this.$emit('update-loading', true);
            this.SelectedTags.forEach(async tag => {
                try {
                    const response = axiosInstance.post("/api/remove_extra_tag", {
                            token: localStorage.getItem('token'),
                            songs: this.selectedSongs,
                            value: tag
                    });
                    const [ res ] = await Promise.all([response]);
                    console.log("SBAddTagToSongs",res);
                    if (res.data.error) { 
                        this.$toast.add({ severity: 'error', summary: 'Error en '+tag, detail: res.data.message, life: 5000, group: 'topr' });
                    }
                } catch (error) {
                    console.error("getYearToDay: There was an error!", error);
                }
            });
            
            setTimeout(() => {
                this.getTagsMusical_list();
            }, 1000); 
        },
        
        async RemoveTagToSongs(songId, tag) {
            this.$confirm.require({
                message: '¿Seguro que quieres eliminar el Tag "'+tag+'" de la Canción "'+songId+'"?',
                header: 'Confirmación de eliminación',
                icon: 'pi pi-info-circle',
                acceptClass: 'p-button-danger',
                accept: async () => {
                    this.$emit('update-loading', true);
 
                    try {
                        const response = axiosInstance.post("/api/remove_extra_tag", {
                                token: localStorage.getItem('token'),
                                songs: [songId],
                                value: tag
                        });
                        const [ res ] = await Promise.all([response]);
                        console.log("SBAddTagToSongs",res);
                        if (res.data.error) { 
                            this.$toast.add({ severity: 'error', summary: 'Error en '+tag, detail: res.data.message, life: 5000, group: 'topr' });
                        }
                    } catch (error) {
                        console.error("getYearToDay: There was an error!", error);
                    } 
                
                    setTimeout(() => {
                        this.getTagsMusical_list();
                    }, 1000);
                    this.$toast.add({ severity: 'info', summary: 'Confirmado', detail: 'Record deleted', life: 3000, group: 'topr' });
                }
            });
        },
        sideBarAddTag(tag){
            console.log('Agregar tag:', tag);
            if (!this.SelectedTags.includes(tag)) {
                this.SelectedTags.push(tag);
            }
            console.log('SelectedTags:', this.SelectedTags);
            
        },
        sideBarRemoveTag(tag){
            console.log('Remove tag:', tag);
            if (this.SelectedTags.includes(tag)) {
                this.SelectedTags.splice(this.SelectedTags.indexOf(tag), 1);
            }
        },
        onPlaySong(location, name, artist) {
            this.$emit('showMusicPlayer', 
                 "https://media.vybroo.com/music/"+location,
                 name, 
                 artist,
                );
        },
        onPlaySongHQ(location, name, artist) {
        this.$emit('showMusicPlayer', 
                 "https://media.vybroo.com/mp3_320/"+location,
                 name, 
                 artist,
                );
        },
        onPlaySongMQ(location, name, artist) {
        this.$emit('showMusicPlayer', 
                 "https://media.vybroo.com/mp3_128_norm/"+location,
                 name, 
                 artist,
                );
        },
        onPlayVideoHD(location, name, artist) {
            this.$emit('showVideoPlayer', 
                 "https://media.vybroo.com/mp4_video/"+location+"?v="+Date.now(),
                 name, 
                 artist,
                );
        },
        handlePageChange(event) {
            console.log('Página EVENT:', event);
            console.log('Página seleccionada:', event.page);
            this.paginaActual = event.page;
            this.getTagsMusical_list();
        },
        handleFilters(event) {
            //alert('Pagina seleccionada:'+event.page);
            console.log('Filtro seleccionada:', event);
            console.log('selectedFilterBy: ',this.selectedFilterBy.code);
            console.log('selectedFilterDirection: ',this.selectedFilterDirection.code);
            this.getTagsMusical_list();
            
        },
        handleSelectedSongs() {
            console.log('Canciones seleccionadas:', this.selectedSongs);
        },
        onRowRightClick(event, id) {
            console.log('onRowRightClick1:', id);
            this.contextMenuIdSelected = id;
            this.$refs.routemenu.show(event);
        },
        selectAllPage() {
            //si todos los checkbox estan seleccionados, entonces deseleccionar todos sino seleccionar todos
            console.log('Seleccionar todas las canciones');
            this.songsList.forEach(song => {
                //si la cancion ya esta seleccionada, no agregarla
                if (!this.selectedSongs.includes(song.id)) {
                    this.selectedSongs.push(song.id);
                } 
            });
            console.log('Canciones seleccionadas:', this.selectedSongs);
            
        },
        unselectAllPage() {
            //si todos los checkbox estan seleccionados, entonces deseleccionar todos sino seleccionar todos
            console.log('Deseleccionar todas las canciones');
            this.songsList.forEach(song => {
                //si la cancion ya esta seleccionada, no agregarla
                if (this.selectedSongs.includes(song.id)) {
                    this.selectedSongs.splice(this.selectedSongs.indexOf(song.id), 1);
                } 
            });
            console.log('Canciones seleccionadas:', this.selectedSongs);
            
        },
        unselectAllPages() {
            //si todos los checkbox estan seleccionados, entonces deseleccionar todos sino seleccionar todos
            console.log('Deseleccionar todas las canciones');
            this.selectedSongs = [];
            console.log('Canciones seleccionadas:', this.selectedSongs);
            
        },
        async getTagsMusical_list() {
            this.$emit('update-loading', true);
            try {
                // Peticion completa, paginación, filtro de texto y orden
                let filterRequest = {
                        token: localStorage.getItem('token'),
                        filtro_text: this.inputFilter,
                        offset: this.paginaActual*100,
                        sort: {
                            direction: this.selectedFilterDirection.code,
                            by: this.selectedFilterBy.code
                        },
                        mode: "audio"
                }; 
                // Si se cuenta con Filtros extras, se agregan a la petición
                if (this.localFilters.length !== 0) {
                    let localFiltersCode = [];
                    this.localFilters.forEach(localFilter => {
                        localFiltersCode.push(localFilter.code);
                    });
                    filterRequest.filters = localFiltersCode;
                }
                const responseF = axiosInstance.post("/api/songs", filterRequest);

                const [ result
                ] = await Promise.all([
                        responseF
                ]);
                this.songsList = result.data.songs;
                this.totalSongs = result.data.total;
                this.numSongsShow = result.data.songs.length;
                
                console.log("SONGS");
                console.log(this.songsList);
                console.log("TOTALSONGS",this.totalSongs);
                console.log("NUMSONGSSHOW",this.numSongsShow);

            } catch (error) {
                console.error("getYearToDay: There was an error!", error);
            }
            this.$emit('update-loading', false);
        },
        loadPagination() {
            this.$emit('update-loading', true);
                let total  = this.totalSongs;
                
                //let shown  = this.numSongsShow;
                //let holder = $('.countBox');
                //let label  = `Mostrando ${shown} de ${total} canciones`;
                //if (total === 1) {
                //label = `Mostrando ${shown} de 1 canción`;
                //}
                //holder.text(label);

            /// PAGINACION DE TAGS LIST --------------------------------
                //let offset  = table.attr('offset' || 0);
                var paginat  = this.paginaActual;
                var limit=100; 
                var totalPaginas = Math.ceil(total/limit);
                if (paginat<0 || paginat>totalPaginas) {
                    paginat = 0;
                    //paginat.val(paginat);
                }
                //totalPaginas = totalPaginas-1;
                var back=paginat-1;
                var next=paginat+1;
                //var final=limit*paginat;
                //var inicio=final-limit;
            //alert('paginat:'+paginat+' limit:'+limit+' totalPaginas:'+totalPaginas+' back:'+back+' next:'+next+' inicio:'+inicio+' final:'+final+' total:'+total);    

                var pagina = ''; 
                pagina+= "<div class='number_pagination'>";
                if (back >= 0) {
                pagina+= "<button class='vxOptionButton t_paginando inicioFinButtons' value='"+back+"'><i class='fa fa-chevron-left'></i></button>";
                }
                var index_ini_aux = paginat - 5;
                var index_fin_aux=paginat+6;
                if (paginat > 6) {
                pagina+= "<button class='vxOptionButton t_paginando' value='0'>1</button>";
                pagina+= "<button class='vxOptionButton dots' >...</button>";
                }
                if (index_ini_aux <= 0) {
                index_ini_aux = 0;
                }
                if (index_fin_aux >= totalPaginas) {
                index_fin_aux = totalPaginas;
                }
                for (let index = index_ini_aux; index < index_fin_aux; index++) {
                var selected="";
                var index_aux = index+1;
                if (index == paginat) { selected=" selected"; }
                pagina+= "<button class='vxOptionButton t_paginando"+selected+"'  value='"+index+"'>"+ index_aux +"</button>";
                }
                if (paginat < (totalPaginas-6)) {
                var totalPaginas_aux = totalPaginas-1;
                pagina+= "<button class='vxOptionButton dots' >...</button>";
                pagina+= "<button class='vxOptionButton t_paginando'  value='"+totalPaginas_aux+"'>"+ totalPaginas +"</button>";
                }
                if (totalPaginas > next) {
                pagina+= "<button class='vxOptionButton t_paginando inicioFinButtons' value='"+next+"'><i class='fa fa-chevron-right'></i></button>";
                }
                pagina+= "</div>"; 
                
                this.pagination = pagina;
            /// PAGINACION DE TAGS LIST --------------------------------

                /*if (shown === total) {
                return $('.loadMore').hide();
                } */

            this.$emit('update-loading', false);
        },
        async loadTagsColorList(){
            try {
                //Año actual   ==============================
                const response = axiosInstance.post("/api/tags", {
                        token: localStorage.getItem('token'),
                });

                const [ cList
                ] = await Promise.all([
                    response
                ]);
                this.tagsColorList = cList.data;
                console.log("TAGS COLOR__"); 
                console.log("this.tagsColorList",this.tagsColorList);
                console.log("TAGS COLOR___"); 
                delete this.tagsColorList.success;
                this.ftagsColorList = Object.keys(this.tagsColorList).map(tagName => this.tagsColorList[tagName]);
                console.log("this.ftagsColorList",this.ftagsColorList);
            } catch (error) {
                console.error("loadTagsColorList: There was an error!", error);
            }
        },
        async loadPlayList(){
            try {
                //Año actual   ==============================
                const response = axiosInstance.post("/api/get_filter_storage", {
                        token: localStorage.getItem('token'),
                        mode: "audio"
                });

                const [ cList
                ] = await Promise.all([
                    response
                ]);
                
                this.playlists = cList.data.filters;
                this.fplaylists = Object.keys(this.playlists).map(tagName => this.playlists[tagName]);
                console.log("playlists__"); 
                console.log("ssssssssssssssssssss",cList.data.filters);  
            } catch (error) {
                console.error("loadTagsColorList: There was an error!", error);
            }
        },
        async uploadTableTag(){
            try {
                const title_res = axiosInstance.post("/api/save_tag", {
                        token: localStorage.getItem('token'),
                        index: 1,
                        value: this.songSBtitle,
                        songs: [this.tagSelectedSong]
                });

                const artist_res = axiosInstance.post("/api/save_tag", {
                        token: localStorage.getItem('token'),
                        index: 2,
                        value: this.songSBartist,
                        songs: [this.tagSelectedSong]
                });

                const genere_res = axiosInstance.post("/api/save_tag", {
                        token: localStorage.getItem('token'),
                        index: 3,
                        value: this.songSBgenere,
                        songs: [this.tagSelectedSong]
                });

                const year_res = axiosInstance.post("/api/save_tag", {
                        token: localStorage.getItem('token'),
                        index: 4,
                        value: this.songSBanio,
                        songs: [this.tagSelectedSong]
                });

                const [ title_response,
                        artist_response,
                        genere_response,
                        year_response
                ] = await Promise.all([
                        title_res,
                        artist_res,
                        genere_res,
                        year_res
                ]);

                console.log("title_response",title_response);
                console.log("artist_response",artist_response);
                console.log("genere_response",genere_response);
                console.log("year_response",year_response);
                if (title_response.data.success && 
                    artist_response.data.success && 
                    genere_response.data.success && 
                    year_response.data.success) {
                    this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'La cancion se actualizo correctamente', life: 5000, group: 'topr' });
                    this.getTagsMusical_list();
                }else{
                    let resMessage = "";
                    if (!title_response.data.success) {
                        resMessage += "Error en el titulo: "+title_response.data.message+" ";
                    }
                    if (!artist_response.data.success) {
                        resMessage += "Error en el artista: "+artist_response.data.message+" ";
                    }
                    if (!genere_response.data.success) {
                        resMessage += "Error en el genero: "+genere_response.data.message+" ";
                    }
                    if (!year_response.data.success) {
                        resMessage += "Error en el año: "+year_response.data.message;
                    }

                    this.$toast.add({ severity: 'error', summary: 'Error', detail: resMessage, life: 5000, group: 'topr' });
                }
                  
            } catch (error) {
                console.error("uploadTableTag: There was an error!", error);
            }
        },
    },
    mounted() {
        this.selectedFilterBy = this.filterBy[0];
        this.selectedFilterDirection = this.filterDirection[0];
        console.log('Tags Musical  ======================');
        try {
            if (localStorage.getItem('clientData') === null) {
                console.log("clientData IS NULL");
                console.log("redireccionando a login");
                this.$router.push({ name: 'login' });
            } else {
                this.loadTagsColorList();
                this.loadPlayList();
                console.log("clientData IS NOT NULL");
                const tokenId = JSON.parse(localStorage.getItem('clientData'));
                console.log(tokenId);
                console.log("tokenId.name:"+tokenId.name); 
                  
                this.user_permission = tokenId.permissions;
                this.name = tokenId.name;
                this.token = localStorage.getItem('token');

                this.getTagsMusical_list();
            }
        } catch (error) {
            console.log("Error al obtener el usuario: "+error); 
        }
 
    }
}
</script>

<style>
.song_sb_saveButton{
    margin: 10px auto !important;
    display: block !important;
    width: 180px !important;
}
.row_sb_table {
    display: block !important;
}
.row_sb_table p {
    width: 100% !important;
    margin: 10px 0px 0px 0px !important;
}
.row_sb_table input {
    width: 100% !important;
}
 
.fileList_upload > li > .item{
    margin: 2px 0px;
    background: #2b2b2b;
    padding: 2px 0px 2px 5px;
}
.fileList_upload > li > .item > .l_col{
    width: calc(100% - 100px);
}
.fileList_upload > li > .item > .l_col > div{
    max-width: 100%;
}
.fileList_upload > li > .item > .l_col .name{ 
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    display: inline-block;


}
 
.fileList_upload > li > .item > .r_col .stat_span{
    line-height: 22px;
    font-size: 14px;
    padding: 0px 6px 0px 21px;
    margin: 9px 0px;
    border-radius: 3px;
    text-transform: capitalize;
    display: inline-block;
    position: relative;
}
.fileList_upload > li > .item > .r_col .stat_span > svg{
    font-size: 14px;
    position: absolute;
    left: 4px;
    top: 4px;
}
.fileList_upload > li > .item > .r_col .stat_espera{
    background-color: #174ec4;
    color: #FFF
}
.fileList_upload > li > .item > .r_col .stat_subiendo{
    background-color: #FFA500;
    color: #FFF;
}
.fileList_upload > li > .item > .r_col .stat_terminado{
    background-color: green;
    color: #FFF
}
.fileList_upload > li > .item > .r_col .stat_error{
    background-color: red;
    color: #FFF;
}
.fileList_upload > li > .item > .r_col .stat_eliminado{
    background-color: red;
    color: #FFF;
}
 

.fileList_upload > li > .item > .r_col .stat_subiendo > svg{
    animation: rotatee 2s linear infinite;
}
@keyframes rotatee {
    from {
        transform: rotate(0deg)  ;
    }
    to {
        transform: rotate(360deg)  ;
    }
} 
 


.sidebarTitle{
    position: absolute;
    left: 25px;
    top: 12px;
    font-size: 25px;
}
.localFilter{
    display: inline-block;
    background-color: #141414;
    padding: 5px 6px;
    border-radius: 5px;
    width: 100%;
    margin: 2px 0px 0px 2px;
}
.localFilter:hover{
    background-color: #000000;
}
.localFilter .localFilterLabel{
    margin: 0px 5px;
}
.localFilter .localFilterClose{
    cursor: pointer;
    margin: 0px 5px 0px 5px;
    float: right;
}
.localFilter .localFilterClose:hover{
    scale: 1.2;
}

.tagFilterPlaylist {
    cursor: pointer;
    position: relative;
    margin: 2px 4px !important;
    color: #FFF !important;
}
.todos .tagFilterPlaylist {
    opacity: 0.4;
}
.tagFilterPlaylist svg {
    position: absolute;
    right: -3px;
    top: -3px;
    background: white;
    border-radius: 200px;
    padding: 1px;
    opacity: 0;
    z-index: 3;
}
.tagFilterPlaylist:hover svg,
.tagFilterPlaylist:focus svg {
    opacity: .8;
}
.tagFilterPlaylist .fa-circle-plus{
    color: green;
}

.tagFilterPlaylist .fa-circle-minus{
    color: red;
}
.tagFilterPlaylist::before {
    content: "";
    position: absolute;
    left: 1px;
    bottom: 1px;
    top: 1px;
    right: 1px;
    background-color: #141414;
    border-radius: 3px;
    z-index: 1;
}
.tagFilterPlaylist:hover::before {
    opacity: 0.2;
}
 
.tagFilterPlaylist > div {
    z-index: 2;
}
.guardarPlaylistModal .p-dialog-content {
    position: relative;
    max-height: 340px;
}
.guardarPlaylistModal .p-dialog-content::before {
    content: "";
    position: fixed;
    left: 0px;
    bottom: 55px;
    right: 0px;
    height: 40px;
    background: linear-gradient(0deg, rgba(30,30,30,1) 0%, rgba(30,30,30,0) 100%);
    z-index: 1;
}
.guardarPlaylistModal .p-dialog-footer {
    padding: 0.5rem 1rem !important;
}
 
.filterSideBarVisible{
    width: 360px !important;
}
.filterTypeDiv {
    background-color: #141414;
    padding: 5px 8px;
    border-radius: 8px;
}
.filterTypeDiv .p-selectbutton .p-button {
    padding: 4px 5px;
    font-size: 12px;
}
.filterTypeDiv .filterType {
    width: 100%;
    margin: 0px 0px 10px 0px;
}
.filterTypeDiv .filterContent,
.filterTypeDiv .filterDuration {
    width: 100%;
    margin: 0px 0px 10px 0px;
    padding: 0px;
}
.filterTypeDiv .filterContent > div {
    width: 50%; 
    text-align: center;
}
.filterTypeDiv .filterDuration > div {
    width: 33.33%; 
    text-align: center;
}
.filterTypeDiv .filterContent > div span,
.filterTypeDiv .filterDuration > div span{
    padding: 0px;
    margin: auto;
}
.filterTypeDiv .filterInput {
    width: 100%;
    padding: 4px 10px;
    margin: 0px 0px 10px 0px;
}
.filterInputDiv {
    margin-bottom: 10px;
}
.filterInputDiv .p-clickable {
    cursor: pointer;
}
.filterInputDiv .p-clickable:hover {
    background-color: #141414;
    color: #FFF;
    font-weight: bold;
}
.playlistDropDown {
    width: 100%;
    bottom: 0;
    position: absolute !important;
    left: 0;
    border-radius: 0 !important;
    border-width: 1px 0 0 0 !important;
}
.sb_addCloButton {
    width: calc(50% - 2px) !important;
    margin-bottom: 2px !important;
    padding: 8px 40px !important; 
}
.sb_addCloButton_1 {
    margin-right: 2px !important;
}
.sb_addCloButton_2 {
    margin-left: 2px !important;
}
.sb_playListButton {
    width: calc(100% - 4px);
    bottom: 45px;
    left: 2px;
    position: absolute !important;
    text-align: center !important;
    padding: 8px 85px !important;
} 
.sb_removePlayListButton{
    position: fixed !important;
    bottom: 0px;
    left: 360px;
    padding: 11px !important;
}
._tagLone_,
._tagLoneundefined_ {
    display: none !important;
}
.tagSB {
    cursor: pointer;
    position: relative;
}
.tagSB svg {
    position: absolute;
    right: -3px;
    top: -3px;
    background: white;
    border-radius: 200px;
    padding: 1px;
    opacity: 0;
    z-index: 3;
}
.tagSB:hover svg,
.tagSB:focus svg {
    opacity: .8;
}
.tagSB .fa-circle-plus{
    color: green;
}

.tagSB .fa-circle-minus{
    color: red;
}
.tagSB::before {
    content: "";
    position: absolute;
    left: 1px;
    bottom: 1px;
    top: 1px;
    right: 1px;
    background-color: #141414;
    border-radius: 3px;
    z-index: 1;
}
.tagSB > div {
    z-index: 2;
}
.tagColoredd{
    position: relative;
}
.tagColoredd::before {
    content: "";
    position: absolute;
    left: 1px;
    bottom: 1px;
    top: 1px;
    right: 1px;
    background-color: #141414;
    border-radius: 3px;
    z-index: 1;
}
.tagColoredd > div {
    z-index: 2;
}

.sb_addRemButton {
    width: calc(50% - 2px) !important;
    margin-bottom: 10px !important;
    padding: 8px 30px !important;
}
.sb_addRemButton_1 {
    margin-right: 2px !important;
}
.sb_addRemButton_2 {
    margin-left: 2px !important;
}
.sb_addRemButton svg{
    margin-right: 5px !important;
}
.selected_tags_sb {
    background: #141414;
    margin: 5px 0px 0px 0px;
    padding: 1px 7px;
    min-height: 120px;
    border-radius: 4px;
}
.addTagButton {
    color: #FFF !important;
    background: linear-gradient(145deg,rgba(172, 50, 228, .2) 0%, rgba(121, 24, 242,.2) 48%, rgba(72, 1, 255 , .2) 100%) !important;
    border-radius: 100% !important;
    transition-duration: .2s !important;
}

.addTagButton:hover,
.addTagButton:focus,
.addTagButton:active {
    color: #FFF !important;
    scale: 1.1;
    margin-top: -3px !important;
    background: linear-gradient(145deg,rgba(172, 50, 228, .7) 0%, rgba(121, 24, 242,.7) 48%, rgba(72, 1, 255 , .7) 100%) !important;
    border-radius: 100% !important;
}

.tag {
    color: #FFF !important;
    text-shadow: 1px 1px 10px black;
    background: linear-gradient(145deg,#4b4b4b 0%,#4d4d4d 48%,#333333 100%) !important
    /*background: linear-gradient(145deg,#AC32E4 0%,#7918F2 48%,#4801FF 100%) !important;*/
}
.sticky-top-bar {
    position: sticky;
    top: 0;
    padding: 5px 0;
    z-index: 1000;
}

.icon-button{ 
    padding: 2px 10px !important;
    color: #FFF;
    height: 30px;
}
.icon-button i {
    margin-right: 5px; /* Espaciado entre el icono y el texto */
}
.p-buttonset {
    margin: 0 10px;
}
 
.selectedFilterBy {
    width: 120px;
    height: 30px;
}
.selectedFilterDirection {
    width: 90px;
    height: 30px;
}
.selectedFilterBy span{
    padding: 2px; 
}
.selectedFilterDirection span{
    padding: 2px; 
}
.inputFilter {
    width: 200px;
    height: 30px;
    line-height: 30px;
}
.tagAdd > .p-tag > .p-tag-icon {
    margin: 0;
}
.tagList_td .p-tag{
    padding: 2px 4px;
}
 
.tagList_td .p-tag > div > .text{
    margin-right: 0px;
    font-size: 12px;
    line-height: 12px;
}
.tagList_td .p-tag > div > .close{
    margin-left: 0px;
    cursor: pointer;
    font-size: 12px;
    line-height: 12px;
}
.tagAdd {
    cursor: pointer;
}
.tagAdd > .p-tag {
    margin: 0;
    padding: 2px;
}
.tagAdd > .p-tag > .p-tag-icon {
    font-size: 12px;
    line-height: 12px;
}
.tagsTableData {
    font-family: roboto;
    width: 100%;
}
.tagsTableData thead {
    background-color: #f4f4f5;
    color: #18181b;
    position: sticky;
    top: 77px;
    z-index: 1;
}
.tagsTableData thead th {
    padding: 5px 10px;
    font-size: 12px;
    line-height: 12px;
    font-weight: bold;
    color: #18181b;
}
.tagsTableData tbody tr td {
    padding: 5px 6px;
    font-size: 12px;
    line-height: 14px;
    color: #18181b;
}
.tagsTableData .select{
    width: 20px;
    background-color: transparent;
}
.tagsTableData .id{
     text-align: left;
}
.tagsTableData .title{
     text-align: left;
}
.tagsTableData .artist{
     text-align: left;
}
 
.tagsTableData .year{
    width: 50px;
}
.tagsTableData .duration{
    width: 50px;
}
.tagsTableData .play{
    width: 62px;
}
 
.tagsTableData .date{
    width: 100px;
}
 
.tagsTableData tbody tr:hover {
    background-color: #f4f4f5;
    border-width: 1px;
    border-color: #b36cff;
    border-style: solid;
}
.tagsTableData tbody tr:focus,
.tagsTableData tbody tr:active {
    background-color: #f4f4f5;
    border-width: 1px;
    border-color: #b36cff;
    border-style: solid;
}
.playSong{
    cursor: pointer;
}
.playSongMQ {
    position: relative;
    color: #ff6cb1;
    cursor: pointer;
}
.playSongMQ > span{
    color: #FFF;
    position: absolute;
    bottom: -3px;
    right: -3px;
    background: red;
    font-family: roboto;
    font-size: 8px;
    border-radius: 3px;
    padding: 0px 2px;
    font-weight: bold;
    cursor: pointer;
}
.playSongHQ {
    position: relative;
    color: #b36cff;
    cursor: pointer;
}
.playSongHQ > span{
    color: #FFF;
    position: absolute;
    bottom: -3px;
    right: -3px;
    background: red;
    font-family: roboto;
    font-size: 8px;
    border-radius: 3px;
    padding: 0px 2px;
    font-weight: bold;
    cursor: pointer;
}

.playSongHD {
    position: relative;
    color: red;
    cursor: pointer;
}
.playSongHD > span{
    color: #FFF;
    position: absolute;
    bottom: -3px;
    right: -3px;
    background: rgb(135, 122, 0);
    font-family: roboto;
    font-size: 8px;
    border-radius: 3px;
    padding: 0px 2px;
    font-weight: bold;
    cursor: pointer;
}
.paginatorS .p-paginator-element {
    color: #18181b !important;
    font-size: 12px !important;
    line-height: 28px !important;
    height: 32px !important;
    min-width: 32px !important;
    padding: 0 8px !important;
    margin: 0px 1px !important;
    box-sizing: border-box;
}
.dark .tagsTableData thead {
    background-color: #18181b !important;
    color: #f4f4f5 !important;
}
.dark .tagsTableData thead th {
    color: #f4f4f5 !important;
}
.dark .tagsTableData tbody tr td {
    color: #f4f4f5 !important;
    background-color: #18181b !important;
}
.dark .tagsTableData .select {
    background-color: #222 !important;
}
.dark .tagsTableData tbody tr:hover,
.dark .tagsTableData tbody tr:focus,
.dark .tagsTableData tbody tr:active {
    background-color: #222 !important;
    border-width: 1px;
    border-color: #b36cff;
    border-style: solid;
}
.paginatorS .p-paginator {
    border: 0px;
    padding: 0;
    margin: 5px 0 0 0;
    background-color: transparent;
}
.dark .paginatorS .p-paginator-element {
    color: #f4f4f5 !important;
    font-size: 12px !important;
    line-height: 28px !important;
    height: 32px !important;
    min-width: 32px !important;
    padding: 0 8px !important;
    margin: 0px 1px !important;
    box-sizing: border-box;
}







@keyframes my-fadein {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@keyframes my-fadeout {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}

.my-fadein {
    animation: my-fadein 150ms linear;
}

.my-fadeout {
    animation: my-fadeout 150ms linear;
}
</style>
